import { Link } from 'react-router-dom';

const features = [
  { icon: 'ri-text', label: 'Add Custom Text' },
  { icon: 'ri-image-add-line', label: 'Upload Graphics' },
  { icon: 'ri-drag-move-2-line', label: 'Drag & Reposition' },
  { icon: 'ri-palette-line', label: 'Pick Colors' },
  { icon: 'ri-font-size', label: 'Choose Fonts' },
  { icon: 'ri-rotate-lock-line', label: 'Rotate & Resize' },
];

export function CustomShirtBuilder() {
  return (
    <section className="py-24 px-6 bg-gray-900 relative overflow-hidden">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/0440fa12ea7b643bb6ad27023356ff4c.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Studio preview mockup */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=white%20t-shirt%20mockup%20flat%20lay%20with%20bold%20YOUR%20DESIGN%20placeholder%20text%20printed%20on%20the%20front%20center%2C%20clean%20simple%20product%20photography%20on%20dark%20background%2C%20professional%20custom%20apparel%20print%20design%2C%20crisp%20graphic%20tee%2C%20studio%20lighting%2C%20high%20quality%20shirt%20mockup%20showing%20personalized%20design%20area%20with%20decorative%20elements%20and%20custom%20text%20placeholder&width=900&height=700&seq=studio_your_design_shirt_07&orientation=landscape"
                alt="On Target Prints Design Studio"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 to-transparent"></div>
              <div className="absolute top-4 left-4 flex items-center gap-2 bg-green-500 text-white text-xs font-bold px-3 py-1.5 rounded-full">
                <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                Live Design Studio
              </div>
            </div>

            {/* Floating badge */}
            <div className="absolute -bottom-4 -right-4 bg-[#6B0000] text-white rounded-2xl p-4 shadow-xl">
              <div className="text-2xl font-black">$29.99</div>
              <div className="text-xs text-white/80">Starting price</div>
            </div>
          </div>

          {/* Right: Copy */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-[#6B0000]/30 text-red-300 text-xs font-bold uppercase tracking-widest rounded-full mb-5">
              Design Studio
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-5 leading-tight">
              Build Your Own<br />
              <span className="text-red-300">Game Day Shirt</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed">
              Our full-featured design studio lets you create a one-of-a-kind Bulldogs shirt in minutes. Add text, upload your own graphics, pick colors, and see every change live before you order.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-10">
              {features.map((f, i) => (
                <div key={i} className="flex items-center gap-2.5 bg-white/5 border border-white/10 rounded-xl px-3 py-2.5">
                  <div className="w-7 h-7 flex items-center justify-center bg-[#6B0000]/40 rounded-lg flex-shrink-0">
                    <i className={`${f.icon} text-red-300 text-sm`}></i>
                  </div>
                  <span className="text-white text-xs font-semibold leading-tight">{f.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/customize"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#6B0000] text-white font-bold rounded-xl hover:bg-[#850000] transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-edit-2-line"></i>
                </div>
                Open Design Studio
              </Link>
              <Link
                to="/shop"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 border border-white/20 text-white font-bold rounded-xl hover:bg-white/20 transition-all whitespace-nowrap"
              >
                Browse Ready-Made Tees
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
